import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { MonacoLiquidEditorComponent } from './monaco-liquid-editor.component';

@NgModule({
  declarations: [
    MonacoLiquidEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MonacoEditorModule
  ],
  exports: [
    MonacoLiquidEditorComponent
  ],
  providers: [{
    provide: 'MONACO_PATH',
    useValue: 'https://unpkg.com/monaco-editor@0.18.1/min/vs'
  }],
})

export class MonacoLiquidEditorModule { }
